export default __webpack_public_path__ + "static/media/overreach5.abaa578d.png";